import * as React from 'react';
import {CarCollisionDto} from '../../Models/CollisionModel';
import {Cell, Filter, injectThProps, IReactTableWrapper} from 'HelperFunctions/Lists';
import i18n from '../../Translations/_i18n';
import ReactTable from 'react-table';

export type CollisionListP = {
    data: Array<CarCollisionDto>,
    setActive: (collision: CarCollisionDto) => void,
    onFilterChange: (state: any) => void
}

export type CollisionListS = {
    page: number,
    selected: number,
    activeSorting: string;
    activeFilter: string;
}

export class CollisionList extends React.Component<CollisionListP, CollisionListS> implements IReactTableWrapper {
    constructor(props) {
        super(props);

        this.state = {
            page: 0,
            selected: null,
            activeSorting: '',
            activeFilter: '',
        }
    }

    private collisionDateFilter = Filter.SortFilter.bind(this, i18n.t(`carDetails:collisionDate`));
    private adressFilter = Filter.InputTextFilter.bind(this, i18n.t(`forms:address`), true);
    private vinFilter = Filter.InputTextFilter.bind(this, "Vin", true);
    private licensePlateFilter = Filter.InputTextFilter.bind(this, i18n.t(`carDetails:licensePlate`), true);

    private getTrProps = (state: any, rowInfo: any) => {
        return {
            onClick: () => {
                this.setState({selected: rowInfo.index});
                this.props.setActive(rowInfo.original);
            },
            className: rowInfo ? (rowInfo.index === this.state.selected ? 'active' : '') : ''
        };
    };

    public setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }

    private configColumns = [
        {
            Header: 'hiddenHeader',
            id: 'collisionDate',
            accessor: 'collisionDate',
            Cell: Cell.CutDataTextCall,
            Filter: this.collisionDateFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'address',
            accessor: 'address',
            Cell: Cell.CutTextCell,
            Filter: this.adressFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'vin',
            accessor: 'vin',
            Cell: Cell.CutTextCell,
            Filter: this.vinFilter
        },
        {
            Header: 'hiddenHeader',
            id: 'licensePlate',
            accessor: 'licensePlate',
            Cell: Cell.CutTextCell,
            Filter: this.licensePlateFilter
        },
    ];

    public render() {
        const pageSize = 20;
        const pages = this.props.data ? Math.ceil(this.props.data.length / pageSize) : 1;
        return (

            <div className="table__content">
                <ReactTable
                    // className="reactTable vehicleList--table vehicleList--nomaxheight alertList"
                    data={this.props.data}
                    pages={pages}
                    page={this.state.page}
                    getTheadThProps={injectThProps}
                    defaultPageSize={this.props.data ? (this.props.data.length > pageSize ? pageSize : 0) : pageSize}
                    pageSize={this.props.data ? (this.props.data.length > pageSize ? pageSize : 0) : pageSize}
                    getTrProps={this.getTrProps}
                    onPageChange={page => this.setState({page})}
                    onFetchData={this.props.onFilterChange}
                    columns={this.configColumns}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/History/CollisionList.tsx